import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


export interface OBResponse {
  message?: string,
  IDTransaccion?: string
}

@Injectable({
  providedIn: 'root'
})
export class OnboardingEndpointsService {

  constructor(private _http: HttpClient) {     
  }

  public startOnboarding(userName: string, organization: string, sii: string) {

    const body = {
      userName: userName,
      organization: organization,
      siiPassword: sii,
      requestOrigin: "WEB"
    }

    return this._http.post<any>(`${environment.backend.web_usuarios}/createOrganizationStep1`,  body );
  }

  public onBoardingStep2(userName: string, organization: string, sii: string, idTransaccion: string) {
    const body = {
      userName: userName,
      organization: organization,
      siiPassword: sii,
      requestOrigin: "WEB",
      idTransaccion: idTransaccion
    }
    return this._http.post<any>(`${environment.backend.web_usuarios}/createOrganizationStep2`,  body );
  }
}
